export const selectTimezones = state => state.timezones;
